import styled from 'styled-components';

export const StyledError = styled.div`
  margin-bottom: 10px;
`;
